import { call, put, all } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchOffers(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/offers/offers', {
    query: {}
  });
  yield put({
    // $global: true,
    type: 'SET_OFFERS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* deactivateOffer(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/offers/deactivateOffer', {
    body: {
      offer_hash: payload.offer_hash,
    }
  });
  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* activateOffer(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/offers/activateOffer', {
    body: {
      offer_hash: payload.offer_hash,
    }
  });
  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* turnOnOffers(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/offers/turnOnOffers', {
    body: {}
  });
  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* turnOffOffers(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/offers/turnOffOffers', {
    body: {}
  });
  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* createOfferGroup(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/offers/addOfferGroup', {
    body: {
      offers: payload.offers.map(offer=> offer.offer_hash),
      name: payload.name,
    }
  });
  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* enableOfferGroup(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield payload.offerGroup.offers
    .map(offer_hash => call(Http.post, '/offers/activateOffer', {
      body: {
        offer_hash,
      }
    }));

  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* disableOfferGroup(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield payload.offerGroup.offers
    .map(offer_hash => call(Http.post, '/offers/deactivateOffer', {
      body: {
        offer_hash,
      }
    }));

  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* removeOfferGroup(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.delete, '/offers/offerGroup', {
    body: {
      id: payload.offerGroup._id,
    },
  });
  yield put({
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeFirst('FETCH_OFFERS', fetchOffers),
    takeEvery('DEACTIVATE_OFFER', deactivateOffer),
    takeEvery('ACTIVATE_OFFER', activateOffer),
    takeEvery('TURN_ON_OFFERS', turnOnOffers),
    takeEvery('TURN_OFF_OFFERS', turnOffOffers),
    takeEvery('CREATE_OFFER_GROUP', createOfferGroup),
    takeEvery('ENABLE_OFFER_GROUP', enableOfferGroup),
    takeEvery('DISABLE_OFFER_GROUP', disableOfferGroup),
    takeEvery('REMOVE_OFFER_GROUP', removeOfferGroup),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Offers.sagas.js